/**
 * Query keys for the person's own exercise data (`D200`, `D208`): the pinned
 * notes, the favourites and preferences, goals and strength levels.
 *
 * Under `["exercise"]` and nowhere near `["workout", "history"]`, for the
 * reason `workoutKeys.records` gives: `coveringHistory` reads every entry
 * under that prefix as a history. Goals and strength levels are folded from
 * the sets, so every set write names `goalsAll` and `strengthAll`
 * (`SET_WRITES`), and a weigh-in or a profile write names `strengthAll`.
 */
export const exerciseKeys = {
    all: ["exercise"],
    /** Every note — small, read whole, filtered on the device. */
    notes: ["exercise", "notes"],
    /** Every favourite and preference, read whole. */
    preferences: ["exercise", "preferences"],
    /** The live goals, every exercise's or one's, names in a locale. */
    goals: (options) => [
        "exercise",
        "goals",
        options.exerciseId ?? "all",
        options.locale ?? "en",
    ],
    goalsAll: ["exercise", "goals"],
    /** Every logged lift's level, names in a locale. */
    strengthLevels: (locale) => ["exercise", "strength", "all", locale ?? "en"],
    /** One lift's level, logged or not. */
    strengthLevel: (exerciseId) => ["exercise", "strength", "one", exerciseId],
    strengthAll: ["exercise", "strength"],
};
//# sourceMappingURL=keys.js.map